import React from 'react'
import { inject } from 'mobx-react'
import { Link, withRouter } from 'react-router-dom'
import { formatDate } from '@atheneum/api/dist/lib'
import PropTypes from 'prop-types'

const EmployeeItem = ({
  employee,
  selected,
  staticData,
  atheneumOfficeStore,
  onLink
}) => {
  const { names } = staticData
  const { atheneumOffices } = atheneumOfficeStore
  const { employeePositions } = names
  const position = employeePositions[employee.employeePositionId]
  const office = atheneumOffices.find(
    office => office.id === employee.atheneumOfficeId
  )
  const status = employee.status ? 'active' : 'inactive'
  const className = 'search-item contacts'
  return (
    <div>
      <div
        style={{ position: 'relative' }}
        className='expert-search-item-container'
      >
        <Link
          onClick={e => onLink(e, employee.id)}
          to={`/employee/${employee.id}`}
        >
          <div className={selected ? `${className} active` : className}>
            <div>
              <span className='name'>
                {employee.title} {employee.fullName}
              </span>
              <div>
                {position}, {office.name}
              </div>
              <div>
                <span className='search-item-date'>
                  {formatDate(employee.createdAt)}
                </span>
                <div className={`status-label status-label-${status}`}>
                  {status.toUpperCase()}
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

EmployeeItem.propTypes = {
  staticData: PropTypes.object,
  atheneumOfficeStore: PropTypes.object,
  employee: PropTypes.object,
  selected: PropTypes.bool,
  onLink: PropTypes.func
}

export default withRouter(
  inject('staticData', 'atheneumOfficeStore')(EmployeeItem)
)
